import React from 'react';

const IncastTheme = {
  headerLogo: {
    src: '/themes/theme/incast/incast-header-logo.png',
    alt: 'Incast Logo',
    size: 50,
  },
  darkLogo: {
    src: '/themes/theme/incast/incast-logo.png',
    alt: 'Incast Logo',
    size: 150,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #f06f20',
    height: 50,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Incast Data',
  isLightOnDark: false,
  organisationId: 'a9c52633-eb7d-4730-ac3b-90bc3857cb2c',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="120"
        src="/themes/theme/incast/incast-logo.png" alt="Incast Logo"
      />
      <br /><br />
      <h3>Incast Influencer Marketing</h3>
    </div>
  ),
  shareSite: 'https://shareable.incast.us',
};

export default IncastTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/incast.js
 **/